(ns nl.mediquest.questionnaire-frontend.translations)

(def translations
  {:notifications/do-not-participate
   {:nl "U heeft ervoor gekozen om (op dit moment) niet mee te doen met de scan."
    :en "You have chosen not to participate in the scan at this time."}
   :notifications/empty-survey-response-not-send
   {:nl "Er zijn geen antwoorden ingevoerd. Wilt u alsnog meedoen, open dan de vragenlijst opnieuw."
    :en "No answers were entered. Reopen the questionnaire if you still want to participate."}
   :notifications/max-number-filled-in-1
   {:nl "Voor deze code is het maximaal aantal van " :en "For this code, the maximum number of "}
   :notifications/max-number-filled-in-2
   {:nl " ingevulde scans bereikt. " :en " scans has been reached. "}
   :notifications/max-number-filled-out-reached
   {:nl "Het limiet van deze vragenlijstcode is bereikt." :en "The limit of this questionnaire code has been reached."}
   :notifications/already-filled-out
   {:nl "Deze vragenlijstcode is al gebruikt." :en "This questionnaire code has already been used."}
   :notifications/expired
   {:nl "Deze vragenlijstcode is verlopen. U kunt niet meer deelnemen aan de vragenlijst."
    :en "This questionnaire code has expired. You can't participate on this questionnaire anymore."}
   :notifications/contact-helpdesk
   {:nl "Neem contact op met de helpdesk."
    :en "Please contact the helpdesk."}
   :notifications/unknown-code
   {:nl "Deze vragenlijstcode is niet bekend." :en "This questionnaire code is unknown."}
   :notifications/retrieval-error
   {:nl "Er is iets misgegaan bij het ophalen van de vragenlijst.",
    :en "Something went wrong while retrieving the questionnaire."}
   :notifications/login-code
   {:nl "De vragenlijstcode voor uw werknemers is "
    :en "The questionnaire code for your employees is "}
   :notifications/use-following-url
   {:nl "Gebruik de volgende URL voor de Vitaliteitscheck: "
    :en "Use the following URL for the Vitality Check: "}
   :notifications/successful-save
   {:nl "De vragenlijst is opgeslagen" :en "The questionnaire has been saved"}
   :notifications/successful-draft-save
   {:nl "Uw voortgang is tijdelijk opgeslagen. U kunt de vragenlijst later hervatten met dezelfde link."
    :en "Your progress has been saved temporarily. You can resume the questionnaire later using the same link."}
   :notifications/something-wrong-save
   {:nl "Er is iets misgegaan bij het opslaan van de vragenlijst"
    :en "Something went wrong while saving the questionnaire"}
   :survey/save-draft
   {:nl "Tussentijds opslaan" :en "Save for later"}
   :notification/invalid-url
   {:nl "De url van het rapport is helaas niet geldig."
    :en "The report's URL is unfortunately not valid."}
   :notification/something-wrong-emailing
   {:nl "Er is iets misgegaan met het verzenden van de e-mail. Probeer het later
        nog een keer.",
    :en "Something went wrong while sending the email. Please try again later."}
   :notification/email-sent-successfully
   {:nl "De e-mail is verstuurd."
    :en "The email has been sent."}
   :landing-page/questionnaire
   {:nl "Vragenlijst" :en "Questionnaire"}
   :landing-page/unsubscribe-page
   {:nl "Uitschrijfpagina" :en "Unsubscribe page"}
   :landing-page/code
   {:nl "Vragenlijstcode" :en "Questionnaire code"}
   :landing-page/organization-code
   {:nl "Organisatiecode" :en "Organization code"}
   :landing-page/retrieve
   {:nl "Vragenlijst ophalen" :en "Retrieve questionnaire"}
   :landing-page/title
   {:nl "Hoe vitaal voel jij je?" :en "How healthy do you feel?"}
   :landing-page/error
   {:nl "Momenteel is deze applicatie niet bereikbaar, probeer het later nogmaals."
    :en "This application is unavailable at the moment, try again later."}
   :landing-page/introduction
   {:nl "Door de scan in te vullen kom je erachter wat er allemaal meespeelt bij
        jezelf vitaal voelen. Hoe gaat het met je en hoe ziet je leefstijl
        eruit? Ervaar je balans tussen je werk- en privéleven? Wat is voor jou
        belangrijk en zou je het leuk vinden om ergens mee aan de slag te gaan?
        Het invullen van de vragenlijst duurt 10-15 minuten. Na het invullen
        krijg je een persoonlijk rapport."
    :en "By filling out the scan, you will find out what is involved in feeling
        healthy. How are you doing and what does your lifestyle look like? Do
        you experience a balance between your work and private life? What is
        important to you and would you like to work on something? Filling out
        the questionnaire takes 10-15 minutes. After filling it out, you will
        receive a personal report."}
   :landing-page/fill-in-code
   {:nl "Vul hieronder de code in om de scan te starten."
    :en "Enter the code below to start the scan."}
   :landing-page/anonymous
   {:nl "Je deelname is anoniem" :en "Your participation is anonymous"} ; header only
   :landing-page/mediquest
   {:nl "De uitvoering van dit onderzoek is uitbesteed aan het onafhankelijke
        onderzoeksbureau Mediquest. Mediquest verwerkt alle gegevens zorgvuldig,
        vertrouwelijk en anoniem. Niemand kan achterhalen of je mee hebt gedaan
        en wat jij persoonlijk hebt geantwoord. Meedoen aan de scan is geheel
        vrijwillig. Lees "
    :en "This research is outsourced to the independent research agency
        Mediquest. Mediquest processes all data carefully, confidentially and
        anonymously. No one can find out if you have participated and what you
        have personally answered. Participation in the scan is entirely
        voluntary. Read "}
   :landing-page/here
   {:nl "hier" :en "here"}
   :landing-page/full-statement
   {:nl "het hele privacy statement." :en "the full privacy statement."}
   :landing-page/questions
   {:nl "Vragen?" :en "Questions?"}
   :landing-page/contact
   {:nl "Neem contact op met de helpdesk op telefoonnummer 088-1263900 (lokaal
        tarief) of mail naar "
    :en "Contact the help desk at phone number 088-1263900 (local rate) or email "}
   :landing-page/contact-vitaliteitsscan
   {:nl "Neem contact op met de helpdesk op telefoonnummer 088-1263920 (lokaal
        tarief) of mail naar "
    :en "Contact the help desk at phone number 088-1263920 (local rate) or email "}
   :landing-page/unfortunately
   {:nl "Helaas," :en "Unfortunately,"}
   :landing-page/unavailable
   {:nl "de vragenlijst die je probeert op te vragen is niet (meer) beschikbaar."
    :en "the questionnaire you are trying to retrieve is not or no longer available."}
   :landing-page/unavailable-reason
   {:nl " Om de volgende reden:" :en " For the following reason:"}
   :landing-page/welcome
   {:nl "Welkom bij de vragenlijst " :en "Welcome at the questionnaire "}
   :landing-page/at-code-below
   {:nl "Vul hieronder je code in om de vragenlijst te starten."
    :en "Fill in your code below to start the questionnaire."}
   :thank-you-page/message
   {:nl "Dank voor het invullen van de vragenlijst "
    :en "Thank you for filling in the questionnaire "}
   :privacy/analysis
   {:nl "Mediquest t.b.v. analyse en onderzoek van de
        vragenlijsten, behoefte en aansluiting van het aanbod op de behoefte. De
        resultaten zijn niet te herleiden naar jou als persoon en niet naar het
        bedrijf waar je voor werkt."
    :en "Mediquest and development partners to analyse and research the
        questionnaire, to match demand to supply. The results cannot be traced
        back to you personally nor to the company you work for."},
   :privacy/download {:nl "downloaden.", :en ""},
   :privacy/full-statement
   {:nl "Het volledige privacy statement kun je "
    :en "You can download the complete privacy statement "},
   :privacy/here {:nl "hier", :en "here."},
   :privacy/independent
   {:nl "De scan wordt uitgevoerd door onafhankelijk onderzoeksbureau Mediquest.
        Alle gegevens worden vertrouwelijk verwerkt door Mediquest, volgens de
        huidige wet- en regelgeving."
    :en "This scan is conducted by independent research agency, Mediquest.
        Mediquest processes all data confidentially, in accordance with current
        laws and regulations."},
   :privacy/not-traceable
   {:nl "Je werkgever in een totaalrapport om een passend vitaliteitsprogramma
        te kunnen samenstellen. De resultaten in dit rapport zijn pas zichtbaar
        als er tien ingevulde scans zijn en hierdoor niet te herleiden naar jou
        als persoon."
    :en "Your employer as part of an overall report so they can put together an
        appropriate vitality programme. The results of the report can only be
        seen if ten scans have been filled in and consequently the cannot be
        traced back to you personally."}
   :privacy/permission
   {:nl "Als je meedoet aan de scan dan geef je Mediquest eerst toestemming om
        je gegevens te verwerken en op groepsniveau terug te koppelen naar:"
    :en "When you do the scan you first need to give Mediquest permission to
        process your data and at a group level to send feedback to:"}
   :privacy/voluntary
   {:nl "Deelname aan de scan is geheel vrijwillig. Je werkgever weet niet of je
        deelneemt. Ook kan je werkgever niet zien welke antwoorden je hebt
        gegeven. Resultaten worden alleen verstrekt aan jouw werkgever als er
        minimaal tien ingevulde scans zijn en worden op groepsniveau getoond.
        Dit betekent dat de resultaten niet te herleiden zijn naar jou als
        persoon."
    :en "Participation in the scan is entirely voluntary. Your employer does not
        know whether you are taking part, nor can they see what answers you
        gave. Results will only be handed to your employer if at least ten scans
        are completed and these will only be presented at group level. That
        means the results cannot in any way be traced back to individuals."}
   :privacy/what-happens {:nl "Wat gebeurt er met jouw gegevens?", :en "What happens to your data?"},
   :privacy/your-privacy {:nl "Jouw privacy", :en "Your privacy"},
   :report/filled-out-on {:nl "Ingevuld op" :en "Filled out on"}
   :report/measuring-moment {:nl "Meetmoment" :en "Measuring moment"}
   :report/description
   {:nl "Deze scores zijn gebaseerd op jouw antwoorden in de scan. Jouw
        persoonlijke resultaat wordt met niemand gedeeld. Pas wanneer 10
        collega’s de scan hebben ingevuld wordt er een totaalrapport gedeeld met
        je werkgever. Als je ergens mee zit, bedenk dan met wie je hierover zou
        willen praten, Bijvoorbeeld met een vriendin, vertrouwenspersoon, je
        huisarts of je leidinggevende. Je kunt vandaag zelf al aan de slag met
        je vitaliteit. "
    :en "These scores are based on the answers you gave in the scan. Your
        personal results will not be shared with anyone. Only when 10 colleagues
        have completed the scan, will a total report be shared with your
        employer. If you have a problem, have a think about who you would like
        to talk to about it; for example, a friend, a confidential advisor, your
        GP or your manager. You can start working on your vitality today by "}
   :report/description.link
   {:nl "Kijk op de website van vitaliteitsscan voor tips."
    :en "visiting the vitaliteitsscan website for tips."}
   :report/download {:nl "Download PDF", :en "Download PDF"},
   :report/email {:nl "E-mail rapport", :en "Email report"},
   :report/email_1 {:nl "Dit is geen geldig e-mailadres", :en "This is not a valid email address"},
   :report/email_2 {:nl "Wat is je e-mailadres?*", :en "What is your email address?"},
   :report/email_3 {:nl "Vul hier je e-mailadres in", :en "Enter your email address here"},
   :report/email_4 {:nl "Verstuur rapport", :en "Send report"},
   :report/email_5
   {:nl "* Wij gebruiken je e-mailadres alleen om het rapport te versturen, we slaan het niet op.
          Je e-mailadres wordt uitsluitend gebruikt om het persoonlijke rapport te verzenden en wordt daarna direct verwijderd en niet opgeslagen."
    :en "* We will only use your email address to send the report, we will not store it.
        Your email address will only be used to send the report, will be deleted immediately and not be stored."}
   :report/lifestyle.title {:nl "Zo ziet jouw leefstijl eruit", :en "What your lifestyle looks like"}
   :report/lifestyle.title.description
   {:nl "Deze scores zijn berekend op basis van jouw antwoorden. Is het balkje
        helemaal vol? Super! Dan gaat het goed of dan voldoe je aan de
        richtlijn. Is er nog ruimte over? Dan kun je bedenken of je daar iets
        aan wil doen. Jij beslist!"
    :en "These scores are calculated according to your answers. Is the bar
        completely full? That's great! That means things are going well or you
        meet the standard. Is there any space left over? If so, you can decide
        whether you want to do something about it. You decide!"}
   :report/lifestyle_1 {:nl "Zo gaat het met jou", :en "This is how you are doing"},
   :report/lifestyle_2
   {:nl "Dit zijn de cijfers die je jezelf op deze onderdelen hebt gegeven."
    :en "These are the scores that you have given yourself in these areas."}
   :report/lifestyle_3 {:nl "Voel me gezond", :en "I feel healthy"},
   :report/lifestyle_4 {:nl "Voel me vrolijk", :en "I feel cheerful"},
   :report/lifestyle_5 {:nl "Vertrouwen in eigen toekomst", :en "Confidence in my own future"},
   :report/lifestyle_6 {:nl "Geniet van mijn leven", :en "I enjoy my life"},
   :report/lifestyle_7 {:nl "Goed contact met andere mensen", :en "Good interaction with others"},
   :report/lifestyle_8 {:nl "Goed voor mezelf zorgen", :en "I take good care of myself"},
   :report/save
   {:nl "Tip! Bewaar je resultaat voor later of om het aan anderen te laten zien."
    :en "Tip! Save your results for later or to show it to others."}
   :report/start.title {:nl "Waar wil jij mee aan de slag?", :en "What do you want to start with?"},
   :report/start.title.description
   {:nl "Het gaat erom dat jij je gezond en energiek voelt, op de manier die bij
        jou past. Als je in de vragenlijst hebt aangegeven dat je ergens mee aan
        de slag wilt, dan zie je dat hieronder."
    :en "It’s about you feeling healthy and energetic in a way that suits you.
        If you have indicated in the questionnaire that you’d like to start
        making improvements, then you can see this below."}
   :report/start_1 {:nl "Voeding", :en "Food"},
   :report/start_10 {:nl "Zitduur", :en "Sitting time"},
   :report/start_11 {:nl "Alcohol & drugs", :en "Alcohol & drugs"},
   :report/start_2 {:nl "Minder drinken", :en "Drink less"},
   :report/start_3 {:nl "Stoppen met roken", :en "Stop smoking"},
   :report/start_4 {:nl "Bewegen", :en "Physical movement"},
   :report/start_5 {:nl "Slaap & mentale balans", :en "Sleep & mental balance"},
   :report/start_6 {:nl "Werkdruk", :en "Workload"},
   :report/start_7 {:nl "Tips om direct te beginnen", :en "Tips to get started at once"},
   :report/start_8 {:nl "Stoppen met drugs", :en "Stop drugs"},
   :report/start_9 {:nl "Anders", :en "Otherwise"},
   :report/tips.title
   {:nl "Bekijk de website van vitaliteitsscan voor onder andere tips, oefeningen
        en handige apps en websites."
    :en "Visit the vitality scan website for tips, examples, exercises and
        links to useful apps and websites."}
   :report/tips.title.button {:nl "Website vitaliteitsscan", :en "Vitality Scan website"},
   :report/title {:nl "Jouw resultaat", :en "Your results"},
   :report/title.work {:nl "Zo vind je het op je werk gaan", :en "How things are going at work"},
   :report/title.work.description
   {:nl "Deze scores zijn berekend op basis van je antwoorden. Is het balkje
        helemaal vol? Dan gaat het waarschijnlijk goed op je werk! Is er nog
        ruimte over? Kijk dan of je er iets aan zou willen doen."
    :en "These scores are calculated according to your answers. Is the bar
        completely full? If so, things are probably going well at work! Is there
        any space left over? See if you’d like to do something about it."}
   :report/vitality.title {:nl "Jouw vitaliteit", :en "Your vitality"},
   :report/vitality.title.description
   {:nl "Je hebt jezelf een totaalcijfer gegeven bij de vraag hoe vitaal je je
        in het algemeen voelt. Dit cijfer zie je hieronder."
    :en "You have given yourself a total score in response to the question on
        how vital you feel in general. You can see this score below."}
   :report/work_1 {:nl "Werkdruk", :en "Workload"},
   :report/work_2 {:nl "Werksfeer", :en "Workplace atmosphere"},
   :navigation-protection/confirm-title
   {:nl "Vragenlijst nog niet verzonden"
    :en "Questionnaire not sent yet"}
   :navigation-protection/confirm-message
   {:nl "U heeft de vragenlijst nog niet verzonden. Als u de pagina nu verlaat, gaan uw antwoorden verloren. Wilt u de pagina verlaten?"
    :en "You have not yet sent the questionnaire. If you leave the page now, your answers will be lost. Do you want to leave the page?"}
   :navigation-protection/confirm-button
   {:nl "Verlaten zonder opslaan" :en "Leave without submitting"}
   :navigation-protection/cancel-button
   {:nl "Annuleren" :en "Cancel"}})
